var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-480 -279) translate(48 279) translate(432)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M13.417 6.844V1H4.563C3.973 1 3.5 1.46 3.5 2.031V21.97C3.5 22.54 3.974 23 4.563 23h14.875c.588 0 1.062-.46 1.062-1.031V7.875h-6.02c-.585 0-1.063-.464-1.063-1.031zm2.833 10.14c0 .284-.24.516-.531.516H8.28c-.292 0-.531-.232-.531-.516v-.343c0-.284.24-.516.531-.516h7.438c.292 0 .531.232.531.516v.343zm0-2.75c0 .284-.24.516-.531.516H8.28c-.292 0-.531-.232-.531-.516v-.343c0-.284.24-.516.531-.516h7.438c.292 0 .531.232.531.516v.343zm0-3.093v.343c0 .284-.24.516-.531.516H8.28c-.292 0-.531-.232-.531-.516v-.343c0-.284.24-.516.531-.516h7.438c.292 0 .531.232.531.516zm4.25-4.903V6.5h-5.667V1h.27c.284 0 .554.107.753.3l4.334 4.212c.2.193.31.455.31.726z",
    transform: "translate(-480 -279) translate(48 279) translate(432)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon-file.a3712813.svg";
export { ForwardRef as ReactComponent };